import basic from './modules/basic'
import index from './modules/index'
import login from './modules/login'
export default { basic, index, login }